export default {
  navbar: {
    experience: 'EXPERIENCIA',
    skills: 'HABILIDADES',
    linkstoprojects: 'PROYECTOS',
    contact: 'CONTACTO',
  },
  about: {
    title: 'SOY MANUEL GOSENDE',
    subtitle: 'FRONTEND DEVELOPER & DISEÑADOR GRÁFICO',
    description1: 'Vivo en Mar del Plata, Argentina, y me apasiona usar la tecnología para crear software que combine funcionalidad y UX/UI para mejorar la vida cotidiana y transformar la forma en que las personas interactúan con el mundo virtual.',
    description2: 'Tengo un sólido conocimiento de HTML, CSS, JavaScript, TypeScript y Next JS para programar, mientras que mis skills en diseño son Illustrator, Photoshop, After Effects, Premiere y Lightroom. Gracias a mi experiencia en diseño, puedo desarrollar páginas web interactivas con una meticulosa atención al detalle. Siempre estoy actualizado con las últimas herramientas y tecnologías de desarrollo web.',
    description3: 'Actualmente, estoy explorando React Native para aplicar mis habilidades al desarrollo de aplicaciones.',
  },
  experience: {
    title: '01 EXPERIENCIA',
    job1: {
      company: 'AIOTEK',
      time: 'SEPTIEMBRE 2023 - ACTUALIDAD',
      position: 'FRONTEND DEVELOPER',
      description: 'Trabajo como Frontend Developer en un producto propio de la empresa. Las tecnologías que utilizo son Typescript, Next y Tailwind para el estilizado del sistema.<br /><br />Trabajo junto a un equipo autogestionado compuesto por desarrolladores, arquitectos y diseñadores. He creado componentes reutilizables, hooks y contextos personalizados para cada funcionalidad.',
    },
    job2: {
      company: 'QWAVEE',
      time: 'ENERO 2022 - AGOSTO 2023',
      position: 'FRONTEND DEVELOPER',
      description: 'Trabajé como Frontend Developer utilizando React, TypeScript, JavaScript, HTML, Material UI y SCSS como mi stack tecnológico, para implementar funcionalidades y estilos a diferentes componentes. He trabajado con APIs REST para obtener datos y renderizarlos en el frontend. También trabajé con Web Services para enviar datos a una pasarela de pagos, e integrado Mailchimp para newsletters y envíos de formularios. Además, tengo experiencia con Programación Orientada a Objetos (POO).<br /><br />Utilicé Git para gestionar el control de versiones de cada proyecto, trabajando con ramas y diferentes entornos para la gestión de pull requests. También he utilizado el protocolo SSH con una arquitectura Cliente-Servidor para desplegar el sitio web en producción.<br /><br />Gracias a las metodologías ágiles, estuve en constante comunicación con el equipo para lograr un desarrollo incremental. Además, realicé demos al cliente después de cada sprint para mostrar el progreso.',
    },
    job3: {
      company: 'PLOOT DISEÑOS',
      time: 'OCTUBRE 2016 - NOVIEMBRE 2021',
      position: 'DISEÑADOR GRÁFICO',
      description: 'Durante los años que trabajé en Ploot Diseños, pude crecer como profesional y adquirir habilidades blandas como la comunicación con los clientes y la interpretación de sus ideas. Fui responsable de tareas en el departamento de Diseño, como la creación de identidades corporativas, marcas, flyers, logotipos, entre otros. También participé en la producción y desarrollo de proyectos en el taller gráfico, como el montaje de señalética, plóteres y letras corpóreas.',
    },
  },
  skills: {
    title: '02 HABILIDADES',
    programmer: 'COMO PROGRAMADOR',
    designer: 'COMO DISEÑADOR',
  },
  linkstoprojects: {
    title: '03 PROYECTOS',
    description: 'A continuación dejo algunos de los proyectos en los que he trabajado durante mi carrera profesional. Te invito a navegar los enlaces para ver los resultados.',
    project1: 'PROYECTOS',
    project2: 'LANIN | DISEÑO WEB',
    project3: 'ILUSTRACIÓN',
    description2: 'Este sitio web fue diseñado y desarrollado por mí utilizando algunas de las herramientas mencionadas anteriormente. A continuación encontrarás los enlaces para ver el mockup de Figma y el código en GitHub.',
    project8: 'FIGMA',
    project9: 'GITHUB',
  },
  projects: {
    viramundo: {
      shortDescription: "Diseño de identidad visual y sitio web institucional para agencia de viajes.",
      description: "Desarrollo integral de marca y diseño de sitio web institucional. El proyecto enfocó su comunicación en el turismo vivencial y explorador, conectando con un público joven mediante una gráfica dinámica y un sitio funcional orientado a la experiencia de viaje."
    },
    full_fisio: {
      shortDescription: "Branding e identidad visual para equipo de kinesiólogos en Tandil.",
      description: "Diseño de identidad de marca integral para un equipo de kinesiólogos. El concepto gráfico comunica rehabilitación activa, prevención y bienestar integral, transmitiendo un enfoque profesional orientado al cuidado de la salud física."
    },
    el_codigo_del_placer: {
      shortDescription: "Diseño de marca orientado a la autenticidad, libertad y empoderamiento femenino.",
      description: "Creación de identidad visual para un espacio de expresión y autoconocimiento. La gráfica refleja feminidad, libertad e independencia, alejándose de estereotipos tradicionales mediante una estética moderna, auténtica y resolutiva."
    },
    arias_arguelles: {
      shortDescription: "Identidad gráfica para empresa de soluciones tecnológicas y fumigación con drones en el agro.",
      description: "Desarrollo de marca y presencia en redes para un servicio agropecuario con drones. La identidad utiliza una tipografía fuerte y elementos dinámicos que transmiten precisión, innovación y acompañamiento constante al productor en el campo."
    },
    bueno_lagarto: {
      shortDescription: "Marca de indumentaria inspirada en la naturaleza, los viajes y la vida al aire libre.",
      description: "Proyecto personal y marca de ropa enfocada en el estilo de vida aventurero, la amistad y el contacto con el entorno natural. Desarrollo integral desde la gestión del producto hasta el diseño gráfico de prendas e imagen visual."
    },
    krenergy: {
      shortDescription: "Diseño de marca enfocado en soluciones de energía renovable y sustentabilidad.",
      description: "Creación de logotipo e identidad visual para marca de energías limpias. El diseño utiliza formas geométricas y una paleta cromática que comunica innovación, sustentabilidad y eficiencia energética."
    },
    lupino: {
      shortDescription: "Diseño de logotipo con estética vintage para discográfica y distribuidora musical.",
      description: "Desarrollo de marca con impronta retro e inspiración vintage para un proyecto orientado a la difusión de vinilos y música analógica, combinando nostalgia y carácter en su gráfica."
    },
    idear: {
      shortDescription: "Identidad de marca para agencia de marketing digital y comunicación.",
      description: "Diseño de logo e identidad corporativa que fusiona conceptos de tecnología, marketing estratégico y diseño visual, logrando una imagen moderna, versátil y orientada a entornos digitales."
    },
  },
  contact: {
    title: 'CONTACTO',
    description: '¡Muchas gracias por visitar mi portfolio!<br />Podés contactarme ',
    link: 'acá.',
    copyright: '@DISEÑO Y @PROGRAMACIÓN',
    name: 'MANUEL GOSENDE',
  },
};
